import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import {
  BaseText,
  ContentDisplay,
  Heading,
  HeadingDisplay,
  ListDisplay
} from '@warrenbrasil/nebraska-web';
import {
  IGetSuggestionDetailsResponse,
  ProductInformartionWithDisclaimer
} from '@/modules/wealth/services/investment-suggestions';
import * as captions from './constants';
import { IDynamicContent } from '@/modules/common/types';
import DynamicContentModal from '@/modules/common/components/DynamicContentModal/DynamicContentModal.vue';
import InstrumentAvatar from '@/modules/trade/components/InstrumentAvatar/InstrumentAvatar.vue';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  suggestionDetails: IGetSuggestionDetailsResponse;
  isInvestment: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SuggestionDetails',
  props: {
    suggestionDetails: null,
    isInvestment: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  suggestionDetails: IGetSuggestionDetailsResponse;
  isInvestment: boolean;
};



const isDynamicContentModalOpen = ref(false);
const dynamicContentModal = ref({
  title: '',
  description: [] as IDynamicContent[],
  showCostsButton: false
});

const showCustomOperationsInfos = computed(() => {
  return !!props.suggestionDetails.athenaProductTransaction;
});

const showTransactionInfos = computed(() => {
  return props.suggestionDetails.transaction?.amount?.formatted;
});

const showProductsInfos = computed(() => {
  return (
    props.suggestionDetails.transaction?.products?.length > 0 &&
    props.suggestionDetails.portfolio
  );
});

const showPortfolioInfos = computed(() => {
  return (
    !(props.suggestionDetails.transaction?.type?.toLowerCase() === 'product') &&
    props.suggestionDetails?.portfolio
  );
});

const toggleDynamicModal = (row: ProductInformartionWithDisclaimer) => {
  if (row) {
    dynamicContentModal.value.title = row.title;
    dynamicContentModal.value.description = row.disclaimer;
    dynamicContentModal.value.showCostsButton = !!row.action;
  }
  isDynamicContentModalOpen.value = !isDynamicContentModalOpen.value;
};

const summaryCaption = computed(() => {
  return props.isInvestment
    ? captions.investmentSummaryCaption
    : captions.redemptionSummaryCaption;
});

const portfolioCaption = computed(() => {
  if (props.suggestionDetails.portfolio?.managementType === 'Manual') return '';
  return props.isInvestment
    ? captions.investmentPortfolioCaption
    : captions.redemptionPortfolioCaption;
});

const showExpireDate = computed(() => {
  const expiredAt = props.suggestionDetails.transaction?.expiredAt;
  return expiredAt && expiredAt?.formatted && expiredAt?.formatted !== '';
});

const amountLabel = computed(() => {
  return props.isInvestment
    ? 'Valor total do investimento'
    : 'Valor total bruto';
});

const productAmountLabel = computed(() => {
  return props.isInvestment
    ? 'Valor do investimento'
    : 'Valor bruto do resgate';
});

return { __sfc: true,props, isDynamicContentModalOpen, dynamicContentModal, showCustomOperationsInfos, showTransactionInfos, showProductsInfos, showPortfolioInfos, toggleDynamicModal, summaryCaption, portfolioCaption, showExpireDate, amountLabel, productAmountLabel, BaseText, ContentDisplay, Heading, HeadingDisplay, ListDisplay, DynamicContentModal, InstrumentAvatar, NebraskaColors }
}

})